import $ from '../node_modules/jquery';

// export function toggleMap() {
//     $(".mob-station-nav a").on("click", function (e) {
//         console.log("dada");
//         e.preventDefault();
//         $(".mob-station-nav li").removeClass("active");
//         $(this).parent().addClass("active");
//
//         var data = $(this).attr('data-target');
//
//         if (data === "#map") {
//             $("#station").hide();
//         } else {
//             $("#map").hide();
//         }
//         $(data).show();
//     });
// }


export function toggleMap(event, val) {
    $(".mob-station-nav li").removeClass("active");
    $(event.target).parent().addClass("active");

    if (val === "#map") {
        $("#station").hide();
    } else {
        $("#map").hide();
    }
    $(val).show();
}


// WEBPACK FOOTER //
// ./stations/helepr.js